import React from 'react';
import NavBarWithRouter from './components/NavBar';
import Home from './components/Home';
import { Navigate, Routes, Route } from './router';

function MainApp() {
  const legacySections = ['about', 'skills', 'education', 'experience', 'projects'];

  return (
    <div className="MainApp">
      <NavBarWithRouter />
      <main className="main" id="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          {legacySections.map((section) => (
            <Route
              key={section}
              path={`/${section}`}
              element={<Navigate replace to={`/#${section}`} />}
            />
          ))}
        </Routes>
      </main>
    </div>
  );
}

export default MainApp;
